import type { CSSProperties } from 'react';
import teamsUrl from '@/assets/svg/location/teams.svg';

interface LocationIconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
  style?: CSSProperties;
}

/**
 * The Microsoft Teams location logo.
 *
 * Same story as its Zoom sibling: a generated SVG component that inlined a
 * raster image as base64 — 46 KB of JavaScript (34.0 KB gzipped) for a 20x20
 * logo, on the entry chunk. Serving the `.svg` by URL moves those bytes out of
 * the bundle.
 *
 * Kept as a component with the same default export and the same intrinsic 20x20
 * so no call site changes. Chakra's `<Icon as={Teams} />` styles it through
 * `className`, which is why that prop is forwarded — its CSS width/height wins
 * over the attributes below, exactly as it did over the old `<svg>`.
 *
 * `alt` is empty because every call site pairs the icon with a text label.
 */
const TeamsLocationIcon = ({
  width = 20,
  height = 20,
  className,
  style,
}: LocationIconProps) => (
  <img
    src={teamsUrl}
    alt=""
    width={width}
    height={height}
    className={className}
    style={{ objectFit: 'contain', ...style }}
  />
);

export default TeamsLocationIcon;
